import React, { useEffect } from 'react';
import { Route, Outlet, useParams, Navigate } from 'react-router-dom';
import '../i18n.js'
import { useTranslation } from 'react-i18next';
import AdminHeader from "../admin/common/header/Header.js"
import AdminSidebar from "../admin/cms/sidebar/Sidebar.js";
import PagesList from "../admin/cms/pages/list.js"
import CustomSwitch from '../CustomSwitch.js';
import PageNotFound from '../components/common/404.js';
import { useDispatch, useSelector } from 'react-redux';
import { updateCustomer, updateSaleperson } from '../source/app/appSlice';
import UpdateTitle from '../source/UpdateTitle.js';
import FrontCms from "../admin/cms/settings/frontCms.js"
import CmsBanners from '../admin/cms/pages/CmsBanners.js';
import AddPage from '../admin/cms/pages/AddPage.js';
import CustomisePage from '../admin/cms/pages/CustomisePage.js';
import BlockList from '../admin/cms/blocks/list.js';
import BlockAdd from '../admin/cms/blocks/addViewEdit.js';

const AdminCmsActive = function ({ Fullhandle }) {
    const { i18n } = useTranslation();
    const { locationId_url } = useParams();
    console.log(locationId_url, "locationId_url");
    if (!locationId_url) {
        // If locationId is not provided, redirect to a 'not found' page or another fallback route
        return <Navigate to="/app/admin/cms/not-found" />;
    }
    localStorage.setItem('middlewareLocations', '');
    return (
        <>
            <div className='main-layout-apps'>
                <div className="main-content-wrapper">
                    <AdminSidebar />
                    <div className='main-content-wrapper-right'>
                        <AdminHeader Fullhandle={Fullhandle} i18n={i18n} />

                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );

};

export default function AdminCmsRoutes({ Fullhandle }) {
    const dispatch = useDispatch();
    const ModulePermission = useSelector((state) => state.app.ModulePermission);
    useEffect(() => {
        localStorage.removeItem("customerdetails")
        localStorage.removeItem("salesdetails")
        dispatch(updateCustomer(undefined));
        dispatch(updateSaleperson(undefined));
    }, [dispatch])
    return (

        <CustomSwitch>
            <Route element={<AdminCmsActive Fullhandle={Fullhandle} />}>
                {ModulePermission?.GIS_setup &&

                    <><Route path="pages" element={<> <UpdateTitle title="CMS Pages" /><PagesList /></>} />
                        <Route path="pages/add" element={<> <UpdateTitle title="Edit  Page" /><AddPage /></>} />
                        <Route path="pages/add/:productId_url" element={<> <UpdateTitle title="Edit  Page" /><AddPage /></>} />
                        <Route path="banners" element={<> <UpdateTitle title="Banners" /><CmsBanners /></>} />
                        <Route path="frontcms" element={<> <UpdateTitle title="CMS Setting" /><FrontCms /></>} />
                        <Route path="/" element={<> <UpdateTitle title="CMS Setting" /><FrontCms /></>} />
                        <Route path="frontcms/:theme" element={<> <UpdateTitle title="CMS Setting" /><CustomisePage /></>} />

                        <Route path="blocks" element={<> <UpdateTitle title="CMS Pages" /><BlockList /></>} />
                        <Route path="blocks/add" element={<> <UpdateTitle title="Add  Blocks" /><BlockAdd /></>} />
                        <Route path="blocks/add/:productId_url" element={<> <UpdateTitle title="Edit  Blocks" /><BlockAdd /></>} />

                    </>
                }
                <Route path='not-found' element={<PageNotFound />} ></Route>
                <Route path='*' element={<PageNotFound />} ></Route>
            </Route>
        </CustomSwitch>

    );
}
